export const AIChat = () => {
    return (
      <div className="ai-chats">
      <div className="ai-chat-head">
        <ul className="ai-chat-details-1">
          <li> </li>
          <li> Bot AI generated </li>
          <li> . </li>
          <li>
            {" "}
            Source: <a className="cursor-pointer">
              {" "}
              Practice Bot{" "}
            </a>{" "}
          </li>
        </ul>
      </div>

      <div className="ai-chat-rows">
        <div className="ai-chat-topic-head">
          <div className="ai-chat-topic-title">
            {" "}
            Capital Gains?{" "}
          </div>
          <ul className="ai-chat-topic-options">
            <li>
              {" "}
              <svg
                width="18"
                height="17"
                viewBox="0 0 18 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.6628 6.41289H12.1267C12.4541 5.69257 12.847 4.57935 12.847 3.3679C12.847 2.25467 12.2249 1.3379 11.1117 0.814026C10.686 0.617574 10.1949 0.617574 9.76925 0.814026C9.3436 1.01048 9.04892 1.37064 8.91796 1.82903L8.72151 2.64757C8.3286 4.12096 7.5428 5.43064 6.42957 6.31467C6.2986 6.41289 6.16763 6.51112 6.03667 6.60935C5.77473 6.15096 5.2836 5.85628 4.69425 5.85628H2.20586C1.35457 5.85628 0.666992 6.54386 0.666992 7.39515V15.3842C0.666992 16.2355 1.35457 16.923 2.20586 16.923H4.69425C5.31635 16.923 5.87296 16.5301 6.10215 16.0063C7.64102 16.4319 9.08167 16.6611 10.6205 16.6611H14.5168C15.4663 16.6611 16.2194 15.9081 16.2194 14.9585C16.2194 14.6639 16.1212 14.3692 15.9902 14.1072C16.4813 13.8126 16.776 13.256 16.776 12.6666C16.776 12.3719 16.6778 12.0772 16.5468 11.8153C17.038 11.5206 17.3326 10.964 17.3326 10.3747C17.3326 9.94902 17.1689 9.52338 16.907 9.2287C17.1689 8.93402 17.3326 8.50838 17.3326 8.08273C17.3654 7.1987 16.6123 6.41289 15.6628 6.41289ZM5.11989 15.4169C5.11989 15.6461 4.92344 15.8426 4.69425 15.8426H2.20586C1.97667 15.8426 1.78022 15.6461 1.78022 15.4169V7.42789C1.78022 7.1987 1.97667 7.00225 2.20586 7.00225H4.69425C4.92344 7.00225 5.11989 7.1987 5.11989 7.42789V15.4169ZM14.5823 9.8508H15.6628C15.9902 9.8508 16.2521 10.1127 16.2521 10.4401C16.2521 10.7676 15.9902 11.0295 15.6628 11.0295H14.3859C14.0912 11.0295 13.8292 11.2914 13.8292 11.5861C13.8292 11.8808 14.0912 12.1427 14.3859 12.1427H15.1062C15.4336 12.1427 15.6955 12.4047 15.6955 12.7321C15.6955 13.0595 15.4336 13.3214 15.1062 13.3214H13.9602C13.6655 13.3214 13.4036 13.5834 13.4036 13.8781C13.4036 14.1727 13.6655 14.4347 13.9602 14.4347H14.5168C14.8442 14.4347 15.1062 14.6966 15.1062 15.024C15.1062 15.3514 14.8442 15.6134 14.5168 15.6134H10.6205C9.11441 15.6134 7.73925 15.4169 6.23312 14.9913V7.8208C6.5278 7.65709 6.82247 7.46064 7.11715 7.23144C8.39409 6.21644 9.3436 4.71031 9.80199 2.97499L9.99844 2.15645C10.0312 1.99274 10.1621 1.89451 10.2276 1.86177C10.2931 1.82903 10.4241 1.79628 10.6205 1.86177C11.3409 2.18919 11.701 2.68032 11.701 3.40064C11.701 5.10322 10.7188 6.67483 10.7188 6.70757C10.6205 6.87128 10.5878 7.10047 10.686 7.26418C10.7842 7.42789 10.9807 7.55886 11.1771 7.55886H15.6628C15.9902 7.55886 16.2521 7.8208 16.2521 8.14822C16.2521 8.47564 15.9902 8.73757 15.6628 8.73757H14.5823C14.2876 8.73757 14.0257 8.99951 14.0257 9.29418C14.0257 9.58886 14.2876 9.8508 14.5823 9.8508Z"
                  fill="#646B84"
                />
                <path
                  d="M3.44981 15.024C3.84764 15.024 4.17014 14.7015 4.17014 14.3037C4.17014 13.9059 3.84764 13.5834 3.44981 13.5834C3.05199 13.5834 2.72949 13.9059 2.72949 14.3037C2.72949 14.7015 3.05199 15.024 3.44981 15.024Z"
                  fill="#646B84"
                />
              </svg>
            </li>
            <li>
              <svg
                width="18"
                height="17"
                viewBox="0 0 18 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.6628 6.41289H12.1267C12.4541 5.69257 12.847 4.57935 12.847 3.3679C12.847 2.25467 12.2249 1.3379 11.1117 0.814026C10.686 0.617574 10.1949 0.617574 9.76925 0.814026C9.3436 1.01048 9.04892 1.37064 8.91796 1.82903L8.72151 2.64757C8.3286 4.12096 7.5428 5.43064 6.42957 6.31467C6.2986 6.41289 6.16763 6.51112 6.03667 6.60935C5.77473 6.15096 5.2836 5.85628 4.69425 5.85628H2.20586C1.35457 5.85628 0.666992 6.54386 0.666992 7.39515V15.3842C0.666992 16.2355 1.35457 16.923 2.20586 16.923H4.69425C5.31635 16.923 5.87296 16.5301 6.10215 16.0063C7.64102 16.4319 9.08167 16.6611 10.6205 16.6611H14.5168C15.4663 16.6611 16.2194 15.9081 16.2194 14.9585C16.2194 14.6639 16.1212 14.3692 15.9902 14.1072C16.4813 13.8126 16.776 13.256 16.776 12.6666C16.776 12.3719 16.6778 12.0772 16.5468 11.8153C17.038 11.5206 17.3326 10.964 17.3326 10.3747C17.3326 9.94902 17.1689 9.52338 16.907 9.2287C17.1689 8.93402 17.3326 8.50838 17.3326 8.08273C17.3654 7.1987 16.6123 6.41289 15.6628 6.41289ZM5.11989 15.4169C5.11989 15.6461 4.92344 15.8426 4.69425 15.8426H2.20586C1.97667 15.8426 1.78022 15.6461 1.78022 15.4169V7.42789C1.78022 7.1987 1.97667 7.00225 2.20586 7.00225H4.69425C4.92344 7.00225 5.11989 7.1987 5.11989 7.42789V15.4169ZM14.5823 9.8508H15.6628C15.9902 9.8508 16.2521 10.1127 16.2521 10.4401C16.2521 10.7676 15.9902 11.0295 15.6628 11.0295H14.3859C14.0912 11.0295 13.8292 11.2914 13.8292 11.5861C13.8292 11.8808 14.0912 12.1427 14.3859 12.1427H15.1062C15.4336 12.1427 15.6955 12.4047 15.6955 12.7321C15.6955 13.0595 15.4336 13.3214 15.1062 13.3214H13.9602C13.6655 13.3214 13.4036 13.5834 13.4036 13.8781C13.4036 14.1727 13.6655 14.4347 13.9602 14.4347H14.5168C14.8442 14.4347 15.1062 14.6966 15.1062 15.024C15.1062 15.3514 14.8442 15.6134 14.5168 15.6134H10.6205C9.11441 15.6134 7.73925 15.4169 6.23312 14.9913V7.8208C6.5278 7.65709 6.82247 7.46064 7.11715 7.23144C8.39409 6.21644 9.3436 4.71031 9.80199 2.97499L9.99844 2.15645C10.0312 1.99274 10.1621 1.89451 10.2276 1.86177C10.2931 1.82903 10.4241 1.79628 10.6205 1.86177C11.3409 2.18919 11.701 2.68032 11.701 3.40064C11.701 5.10322 10.7188 6.67483 10.7188 6.70757C10.6205 6.87128 10.5878 7.10047 10.686 7.26418C10.7842 7.42789 10.9807 7.55886 11.1771 7.55886H15.6628C15.9902 7.55886 16.2521 7.8208 16.2521 8.14822C16.2521 8.47564 15.9902 8.73757 15.6628 8.73757H14.5823C14.2876 8.73757 14.0257 8.99951 14.0257 9.29418C14.0257 9.58886 14.2876 9.8508 14.5823 9.8508Z"
                  fill="#646B84"
                />
                <path
                  d="M3.44981 15.024C3.84764 15.024 4.17014 14.7015 4.17014 14.3037C4.17014 13.9059 3.84764 13.5834 3.44981 13.5834C3.05199 13.5834 2.72949 13.9059 2.72949 14.3037C2.72949 14.7015 3.05199 15.024 3.44981 15.024Z"
                  fill="#646B84"
                />
              </svg>
            </li>
            <li>
              {" "}
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.25033 18.9583H5.75033C2.49199 18.9583 1.04199 17.5083 1.04199 14.25V10.75C1.04199 7.49166 2.49199 6.04166 5.75033 6.04166H9.25033C12.5087 6.04166 13.9587 7.49166 13.9587 10.75V14.25C13.9587 17.5083 12.5087 18.9583 9.25033 18.9583ZM5.75033 7.29166C3.16699 7.29166 2.29199 8.16666 2.29199 10.75V14.25C2.29199 16.8333 3.16699 17.7083 5.75033 17.7083H9.25033C11.8337 17.7083 12.7087 16.8333 12.7087 14.25V10.75C12.7087 8.16666 11.8337 7.29166 9.25033 7.29166H5.75033Z"
                  fill="#646B84"
                />
                <path
                  d="M14.2503 13.9583H13.3337C12.992 13.9583 12.7087 13.675 12.7087 13.3333V10.75C12.7087 8.16666 11.8337 7.29166 9.25033 7.29166H6.66699C6.32533 7.29166 6.04199 7.00832 6.04199 6.66666V5.74999C6.04199 2.49166 7.49199 1.04166 10.7503 1.04166H14.2503C17.5087 1.04166 18.9587 2.49166 18.9587 5.74999V9.24999C18.9587 12.5083 17.5087 13.9583 14.2503 13.9583ZM13.9587 12.7083H14.2503C16.8337 12.7083 17.7087 11.8333 17.7087 9.24999V5.74999C17.7087 3.16666 16.8337 2.29166 14.2503 2.29166H10.7503C8.16699 2.29166 7.29199 3.16666 7.29199 5.74999V6.04166H9.25033C12.5087 6.04166 13.9587 7.49166 13.9587 10.75V12.7083Z"
                  fill="#646B84"
                />
              </svg>
            </li>
          </ul>
        </div>

        <div className="ai-chat-topic-contens">
          <p>
            {" "}
            Income-tax Act contains provisions for computation of
            income from five different sources and income from
            capital gains is one of them. Part E of Chapter IV of
            Income-tax Act, 1961 contains provisions for Income-tax
            Act contains provisions for computation of income from
            five different sources and income from capital gains is
            one of them. Part E of Chapter IV of Income-tax Act,
            1961 contains provisions forIncome-tax Act contains
            provisions for computation of income from five different
            sources and income from capital gains is one of them.
            Part E of Chapter IV of Income-tax Act, 1961 contains
            provisions forIncome-tax Act contains provisions for
            computation of income from five different sources and
            income from capital gains is one of them. Part E of
            Chapter IV of Income-tax Act, 1961 contains provisions
            forIncome-tax Act contains provisions for computation of
            income from five different sources and income from
            capital gains is one of them. Part E of Chapter IV of
            Income-tax Act, 1961 contains provisions for{" "}
          </p>
        </div>

        <div className="ai-chat-topic-questions">
          <ul>
            <li>
              {" "}
              <svg
                width="34"
                height="34"
                viewBox="0 0 34 34"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M24.083 26.1093H18.4163L12.1122 30.3025C11.1772 30.9259 9.91634 30.2601 9.91634 29.1268V26.1093C5.66634 26.1093 2.83301 23.2759 2.83301 19.0259V10.5258C2.83301 6.27584 5.66634 3.4425 9.91634 3.4425H24.083C28.333 3.4425 31.1663 6.27584 31.1663 10.5258V19.0259C31.1663 23.2759 28.333 26.1093 24.083 26.1093Z"
                  stroke="#2698FA"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M17.0001 16.0933V15.7959C17.0001 14.8325 17.5951 14.3225 18.1901 13.9117C18.7709 13.515 19.3517 13.005 19.3517 12.07C19.3517 10.7667 18.3034 9.71832 17.0001 9.71832C15.6967 9.71832 14.6484 10.7667 14.6484 12.07"
                  stroke="#2698FA"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.994 19.4791H17.0067"
                  stroke="#2698FA"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </li>
            <li>
              {" "}
              <a
                className="ai-chat-buttons active cursor-pointer"
              >
                {" "}
                How does GST impact businesses?{" "}
              </a>{" "}
            </li>
            <li>
              {" "}
              <a
                className="ai-chat-buttons cursor-pointer"
              >
                {" "}
                What are the different tax slabs under GST?{" "}
              </a>{" "}
            </li>
            <li>
              {" "}
              <a
                className="ai-chat-buttons cursor-pointer"
              >
                {" "}
                Can you explain it a bit more?{" "}
              </a>{" "}
            </li>
          </ul>
        </div>

        <div className="ai-chat-topic-footer">
          <span className="ai-chat-search">
            <input
              className="ai-chat-search-input"
              placeholder="Ask anything from Practice"
            />
            <span className="ai-chat-search-options">
              <a  className="ai-chat-mic cursor-pointer">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 15.5C14.21 15.5 16 13.71 16 11.5V6C16 3.79 14.21 2 12 2C9.79 2 8 3.79 8 6V11.5C8 13.71 9.79 15.5 12 15.5Z"
                    stroke="#646B84"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M4.34961 9.65002V11.35C4.34961 15.57 7.77961 19 11.9996 19C16.2196 19 19.6496 15.57 19.6496 11.35V9.65002"
                    stroke="#646B84"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M10.6104 6.43C11.5104 6.1 12.4904 6.1 13.3904 6.43"
                    stroke="#646B84"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M11.2002 8.55001C11.7302 8.41001 12.2802 8.41001 12.8102 8.55001"
                    stroke="#646B84"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12 19V22"
                    stroke="#646B84"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </a>
              <a
                className="ai-chat-search-enter cursor-pointer"
              >
                {" "}
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.4297 5.92999L20.4997 12L14.4297 18.07"
                    stroke="#646B84"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M3.5 12H20.33"
                    stroke="#646B84"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </a>
            </span>
          </span>
        </div>
      </div>

      {/* Read more */}
      <div className="ai-chat-readmore">
        <a
          className="button-primary light-dark cursor-pointer"
        >
          {" "}
          Read More{" "}
          <svg
            width="18"
            height="9"
            viewBox="0 0 18 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.9201 0.950012L10.4001 7.47001C9.63008 8.24001 8.37008 8.24001 7.60008 7.47001L1.08008 0.950012"
              stroke="#646B84"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </a>
      </div>
    </div>
    )
}

export default AIChat


 